$(() => {
  var faq_questions = $('.pdp-content-faq__questions .content-section__accordion-item');
  if (faq_questions.length < 4) {
    faq_questions.parents('.pdp-content-faq__questions').addClass('pdp-content-faq__questions-1-col');
  }

  var accordion_items = $('.content-section__accordion-item');
  accordion_items.each(function(i) {
    var input = $('input', this);
    var label = $('label', this);
    var input_name = (input.attr('name') || 'content-section__accordion-item') + i;
    input.attr('id', input_name);
    label.attr('for', input_name);
  });

  var tabs_items = $('.content-section__tabs-item');
  var tabs_content_items = $('.content-section__tabs-content-items > input');
  tabs_items.each(function(i) {
    var input = $(tabs_content_items.eq(i));
    var label = $(this);
    var input_name = (input.attr('name') || 'content-section__tabs-item') + i;
    input.attr('id', input_name);
    label.attr('for', input_name);
  });
  tabs_items.on('click', function() {
    $(this).addClass('active').siblings().removeClass('active');
  });

  var arc_texts = $('.arc-text');
  if (arc_texts.length > 0) {
    initArcText(arc_texts);
  }

  var splides = $('.splide');
  splides.each(function() {
    initSplide(this);
  });

  initShopifyForm();
});

function initArcText(arc_texts) {
  arc_texts.each(function() {
    var text = $(this);
    var text_width = text.width();

    function applyArcText() {
      var W = $(window).width();
      if (W < text_width || W <= 550) {
        if ($.data(text[0], 'arctext')) {
          text.arctext('destroy');
        }
      } else {
        if ($.data(text[0], 'arctext')) {
          text.arctext('set', { radius: 1800 });
        } else {
          text.arctext({ radius: 1800 });
        }
      }
    }

    applyArcText();
    $(window).on('resize', applyArcText);
  });
}

function initSplide(_this) {
  var el = $(_this),
      id = el.attr('id'),
      config = {
        autoHeight: true,
      };

  // condition
  if (id === 'page-instalment-how-slider') {
    // config.pagination = false;
  }

  var splide = new Splide(
    id ? `#${id}` : _this, 
    config
  );
  
  // condition
  if (id === 'page-instalment-how-slider') {
    var bar = splide.root.querySelector( '.page-instalment-how-content__slider-progress-bar' );
  
    splide.on('mounted move', function () {
      var end  = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min( ( splide.index ) / end, 1 );
      bar.style.width = String( 100 / end ) + '%';
      bar.style.left = String( 100 * rate ) + '%';
    });
  }

  splide.mount();
}

// shopify form 
function initShopifyForm(timer = 1000) {
  const MAX_ATTEMPTS = 30;
  let attempts = 0;

  const interval = setInterval(() => {
    attempts++;

    const form = document.querySelector('shopify-forms-embed');
    const shadow = form?.shadowRoot;

    if (shadow && !shadow.querySelector('#custom-shopify-form-css')) {
      const link = document.createElement('link');
      link.id = 'custom-shopify-form-css';
      link.rel = 'stylesheet';
      link.href = window.flow.form.css;
      shadow.appendChild(link);
    }

    const button = shadow?.querySelector('div > button');

    if (button && !button.dataset.clickListenerAttached) {
      button.dataset.clickListenerAttached = 'true';

      button.addEventListener('click', () => {
        initShopifyForm(100);
      });

      clearInterval(interval);
      return;
    }

    if (attempts >= MAX_ATTEMPTS) {
      clearInterval(interval);
    }
  }, timer);
}

// // image
// var PLACEHOLDER = 'https://placehold.co/';
// function watchImg(el) {
//   var img = $(el);
//   if (img.attr('src') === PLACEHOLDER) return;
//   img.on('error', function() {
//     var placeholder_size = `${Math.round(img.parents('div').width() ?? img.width())}x${Math.round(img.parents('div').height() ?? img.height())}`;
//     img.off('error').attr('src', PLACEHOLDER + placeholder_size);
//   });
//   if (el.complete && el.naturalWidth === 0) {
//     var placeholder_size = `${Math.round(img.parents('div').width() ?? img.width())}x${Math.round(img.parents('div').height() ?? img.height())}`;
//     img.attr('src', PLACEHOLDER + placeholder_size);
//   }
// }

// $(document).ready(function() {
//   $('#MainContent img').each(function() { watchImg(this); });
// });

// $(window).on('load', function() {
//   $('#MainContent img').each(function() { watchImg(this); });
// });

// // catch dynamically added images
// if (window.MutationObserver) {
//   new MutationObserver(function(mutations) {
//     mutations.forEach(function(mutation) {
//       mutation.addedNodes.forEach(function(node) {
//         if (node.nodeType !== 1) return;
//         if (node.tagName === 'IMG') {
//           watchImg(node);
//         } else {
//           $(node).find('img').each(function() { watchImg(this); });
//         }
//       });
//     });
//   }).observe(document.body, { childList: true, subtree: true });
// }